<template>
  <div class="home">
    <banner-Component></banner-Component>

    <div class="about">
      <div class="img1">
        <img class="add" src="../assets/home/junan.png" alt="">
        <div class="con">
          <div class="line"></div>
          <p class="title">junan holdings.</p>
          <div class="content">
            <div class="left">
              <p>junan holdings.</p>
              <img src="../assets/home/a.png" alt="">
            </div>
            <div class="right">
              <p class="ta">君行正道 安積德義</p>
              <home-Component class="ta2"></home-Component>
<!--              <p class="ta2">　　{{$t('home').text1}}</p>-->
              <div class="threeText" ref="counts" :class="{'enthree':$i18n.locale === 'en'}">
                <div class="item">
                  <div class="t">
                    <span id="num1">2001</span>
                    <span style="line-height: 10px;"></span>
                  </div>
                  <span class="small">{{$t('home').three[0]}}</span>
                </div>
                <div class="item">
                  <div class="t">
                    <span id="num2">15000</span>
                    <span style="line-height: 10px;">{{$t('home').three[1]}}</span>
                  </div>
                  <span class="small">{{$t('home').three[2]}}</span>
                </div>
                <div class="item">
                  <div class="t">
                    <span id="num3">90000</span>
                    <span style="line-height: 10px;">{{$t('home').three[3]}}</span>
                  </div>
                  <span class="small">{{$t('home').three[4]}}</span>
                </div>
                <div class="item">
                  <div class="t">
                    <span id="num4">2000000</span>
                    <span style="line-height: 10px;">{{$t('home').three[1]}}</span>
                  </div>
                  <span class="small">{{$t('home').three[5]}}</span>
                </div>
              </div>
              <div class="btn" @click="goto(1)">
                <btn-Component></btn-Component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="is">
      <!--    关于-->


      <!--    供应链-->
      <div>
        <gy-Component class="gyl"></gy-Component>
      </div>

      <!--    新闻媒体-->
      <div>
        <xw-Component ></xw-Component>
      </div>

    </div>









<!--    地图-->
    <div class="map ">
      <div class="left">
        <map-Component></map-Component>
      </div>
      <div class="info">
         <div class="item">
            <p>{{$t('home').map[0]}}</p>
           <p>{{$t('home').map[1]}}</p>
         </div>
        <div class="item">
          <p>{{$t('home').map[2]}}</p>
          <p>086-574-87798029</p>
        </div>
        <div class="item">
          <p>{{$t('home').map[3]}}</p>
          <p>086-574-87774225</p>
        </div>
        <div class="item">
          <p>{{$t('home').map[4]}}</p>
          <p>admin@junankg.com</p>
        </div>
      </div>
    </div>


    <div class="ln">
      <div class="left">
        <div class="line"></div>
        <p class="a" v-if=" $i18n.locale === 'zh-CN'">君安理念</p>
        <p class="b" :class="{'enb':$i18n.locale === 'en'}">junan idea</p>
        <p class="c">{{$t('home').ln[0]}}</p>
       <div @click="goto(2)">
         <btn-Component></btn-Component>
       </div>
      </div>
      <div class="right ">
       <div class="item wow fadeInRight" v-for="(item,index) in lnList" :key="index" :style="aStyle(index)" @click="gotoCu(index)" >
         <img :src="item.img" alt="">
         <div class="text">
           <p v-if=" $i18n.locale === 'zh-CN'">{{item.name}}</p>
           <p>{{item.sname}}</p>
         </div>
         <div class="black">
         </div>
         <div class="line line-1"></div>
         <div class="line line-2"></div>
         <div class="line line-3"></div>
         <div class="line line-4"></div>
       </div>
      </div>
    </div>

    <foot-Component></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import mapComponent from '../components/bmap'
  import homeComponent from '../components/homeDia'
  import btnComponent from '../components/btn2'
  import  gyComponent from './gyl'
  import  xwComponent from './xw'
  import footComponent from '../components/foot'
  import { CountUp } from 'countup.js'
  import Scrollbar from 'smooth-scrollbar'
export default {
  name: 'home',
  data(){
    return{
      lnList:[
        {img:require('../assets/home/ln1.png'),name:'企业愿景',sname:'Corporate Vision'},
        {img:require('../assets/home/ln2.png'),name:'企业使命',sname:'Our Mission'},
        {img:require('../assets/home/ln3.png'),name:'核心价值观',sname:'Core Value'}
      ]
    }
  },
  components:{homeComponent,xwComponent,gyComponent,bannerComponent,footComponent,btnComponent,mapComponent,},
  mounted() {
   Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
    scrollbar.scrollTo(0,0)
    localStorage.setItem('index','0')
    this.count()
    this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
    window.pageYOffset=this.scrollbar.scrollTop
    window.pageYOffset=this.scrollbar.scrollTop
    this.scrollbar.addListener(() => {
      $(".is div").each(function() {
        var _this = $(this);
        if ($(window).scrollTop() >= $(this).offset().top - $(window).height() + 400)
        {
          _this.addClass('show');
        }else{
          _this.removeClass('show');
        }
      });
      window.pageYOffset=this.scrollbar.scrollTop
    });
  },
  methods:{
    aStyle(n){
      return {animationDelay:n*0.5+0.5+'s'}
    },
    count(){
      let element=this.$refs.counts;
      let actualTop = element.offsetTop;
      let current = element.offsetParent;
      while (element=element.offsetParent){
        actualTop += element.offsetTop;
        /* current = current.offsetParent; */
      }
      let demoFi1 = new CountUp("num1", 2001);
      let demoFi2 = new CountUp("num2", 15000);
      let demoFi3 = new CountUp("num3", 90000);
      let demoFi4 = new CountUp("num4", 2000000);
      let numok=false;
      let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
      if(scrollbar){
        scrollbar.addListener((status) => {
          if(!numok){
            if(actualTop<status.offset.y+document.body.clientHeight){
              demoFi1.start();
              demoFi2.start();
              demoFi3.start();
              demoFi4.start();
              numok=true;
            }
          }
        });
      }
    },
    gotoCu(n){
      localStorage.setItem('index',2)
      this.$router.push({path:'/culture',query:{top:n}})
    },
    goto(n){
      if(n===1){
        this.$router.push({path:'/about'})
      }else{
        this.$router.push({path:'/culture'})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .home{
    width:100%;
    overflow: hidden;
    .about{
      width:100%;
      .img1{
        width:100%;
        padding-bottom: 60px;
        position: relative;
        height:900px;
        .add{
          width:100%;
          object-fit: cover;
        }
        .con{
          position: absolute;
          top:20%;
          left:15%;
          width:70%;
          .line{
            width:20%;
            height:1px;
            background-color: #828282;
          }
          .title{
            font-size: 45px;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            width:70%;
            margin-top: 30px;
            color:#444546;
          }
          .content{
            width:90%;
            margin-top: 60px;
            display: flex;
            flex-direction: row;
            margin-left: 5%;
            .left{
              display: flex;
              flex-direction: row;
              padding-top: 80px;
              position: relative;
              p{
                text-transform: uppercase;
                font-size: 18px;
                font-weight: bold;
                color:rgba(68, 69, 70, .2);
                position: absolute;
                bottom:-10px;
                left:10px;
                transform: rotate(-90deg);
                transform-origin: left;
              }
              img{
                margin-left: 40px;
                object-fit: cover;
              }
            }
            .right{
              margin-left: 5%;
              width:60%;
              .ta{
                font-size: 25px;
                font-weight: bold;
                background:linear-gradient(to right, #002762, #1E9AD0);
                -webkit-background-clip: text;
                color: transparent;
              }
              .ta2{
                margin-top: 50px;
                font-family: normal;
                font-weight: lighter;
                font-size: 14px;
                line-height: 30px;
              }
              .threeText{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top: 80px;
                font-family: "Microsoft YaHei UI";
                .item{
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                  .t{
                    position: relative;
                    padding-right: 10px;
                    padding-left: 10px;
                    padding-bottom: 10px;
                    span:first-child{
                      font-size: 30px;
                      color:#444546;
                     font-weight: bolder;
                    }
                    span:last-child{
                      position: absolute;
                      top:-5px;
                      right:-20px;
                      font-size: 12px;
                    }
                  }
                  .small{
                    font-size: 14px;
                    color:#444546;
                  }
                }
              }
              .enthree{
                flex-wrap: wrap;
                margin-top: 20px;
                .item{
                  width:50%;
                  margin-top:30px;
                }
              }
              .btn{
                margin-top: 60px;
              }
            }
          }
        }
      }
    }
    .is{
      width:100%;

      div{
        opacity: 0;
        transition: all 2s;
      }
      .show{
        opacity: 1;
      }
    }
    .map{
      width:100%;
      padding-bottom: 80px;
      display: flex;
      flex-direction: row;
      .left{
        height:626px;
        width:60%;
        overflow: hidden;
      }
      .info{
        width:40%;
        display: flex;
        flex-direction: column;
        background-color: #141720;
        color:white;
        font-family: normal;
        font-weight: lighter;
        .item{
          padding: 40px 60px;
          height:20%;
          cursor: pointer;
          transition: all 2s;
          line-height: 30px;
          p:nth-child(2){
            font-size: 14px;
          }
        }
        .item:hover{
          background-color: #1E263E;
        }
      }
    }
    .ln{
      width:1280px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      padding-bottom: 80px;
      .left{
        width:30%;
        .line{
          width:80%;
          height:1px;
          background-color: #828282;
        }
        .a{
          font-size: 25px;
          font-weight: bold;
          color:#04356F;
          padding: 20px 0;
        }
        .b{
          font-size: 45px;
          font-weight: bold;
          text-transform: uppercase;
          color:#444546;
        }
        .enb{
          padding: 20px 0;
        }
        .c{
          font-size: 14px;
          font-family: normal;
          font-weight: lighter;
          margin-top: 60px;
          line-height: 30px;
        }
      }
      .right{
        width:65%;
        margin-left: 5%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .item{
          width:32%;
          overflow: hidden;
          cursor: pointer;
          position: relative;
          img{
            width:100%;
            object-fit: contain;
            transition: all 2s;
          }
          .text{
            position: absolute;
            left:10%;
            width:90%;
            color:white;
            line-height: 25px;
            font-size: 14px;
            bottom:5%;
            z-index: 100;
          }
          .black{
            position: absolute;
            left:0;
            top:0;
            background-color: rgba(0,0,0,.6);
            width:100%;
            height:100%;
            transition: all 1s;
            z-index: 10;
            opacity: 0;
          }
          .line{
            position: absolute;
            background-color:#3B95FF;
            -webkit-transition: .6s;
            transition: .6s;
          }
          .line-1{
            top: 0;
            left: 0;
            width: 0;
            height: 5px;
          }
          .line-2{
            top: 0;
            left: 0;
            width: 5px;
            height: 0;
          }
          .line-3{
            bottom: 0;
            right: 0;
            width: 0;
            height: 5px;
          }
          .line-4{
            bottom: 0;
            right: 0;
            width: 5px;
            height: 0;
          }
        }
        .item:hover{
          img{
            transform: scale(1.05);
          }
          .black{
            opacity: 1;
          }
          .line-1,.line-3{
            width:100%;
          }
          .line-2,.line-4{
            height:100%;
          }
        }
      }
    }
    @media screen and (max-width: 1440px){
      .about{
        .img1{
          .con{
            top:10%;
            width:90%;
            left:10%;
          }
        }
      }
      .cy{
        .swiper{
          .item{
            .main{
              .left{
                p:nth-child(2){
                  font-size: 45px;
                }
                p:nth-child(3){
                  margin-top: 150px;
                }
              }
            }
          }
          .prev,.next{
            bottom:20%;
          }
        }
      }
    }
    @media screen and (max-width:1280px){
      .ln{
        width:1200px;
      }
    }
    @media screen and (max-width:1279px){
    .about{
      .img1{
        .add{
          height:150px;
        }
        .con{
          top:9%;
          .title{
            font-size: 30px;
            width:100%;
            margin-top: 20px;
          }
          .content{
            flex-direction: column;
            width:100%;
            margin-left: 0;
            margin-top: 0;
            .left{
              padding-top: 30px;
            }
            .right{
              width:95%;
              margin-left: 0;
              .ta{
                padding-top: 30px;
              }
              .ta2{
                margin-top: 20px;
                line-height: 30px;
              }
              .threeText{
                margin-top: 30px;
                flex-direction: column;
                .item{
                  flex-direction: row;
                  .t{
                    text-align: left;
                  }
                  .small{
                   line-height: 40px;
                  margin-left: 50px;
                  }
                }
              }
              .enthree{
                .item{
                  width:100%;
                  margin-top: 20px;
                  .small{
                    margin-left: 0;
                  }
                  .t{
                    span:last-child{
                      right:-150px;
                    }
                  }
                }
              }
              .btn{
                margin-top: 0;
              }
            }
          }
        }
      }
    }
      .map{
        flex-direction: column;
        .left{
          width:100%;
          height:400px;
        }
        .info{
          width:100%;
          .item{
            padding: 20px 60px;
          }
        }
      }
      .ln{
        width:95%;
        flex-direction: column;
        .left{
          width:100%;
          .c{
            margin-top: 20px;
          }
        }
        .right{
          width:100%;
          margin-left: 0;
          margin-top: 30px;
        }
      }
    }
  }
  .prev:focus{
    outline: none;
  }
  .next:focus{
    outline: none;
  }
</style>
